const Data = [
  {
    id: "7",
    image: "https://i.ibb.co/4prVfcx/img-4.png",
    url: "https://project-tools-971d9.web.app/",
    type: "development",
    server: "https://github.com/Kanizfatema47/toolmart-server",
    client: "https://github.com/Kanizfatema47/toolmart-client",
    name: "ToolMart",
    img1:" https://i.ibb.co/MGqCjnM/1.png",
    img2:" https://i.ibb.co/FDj99rb/2.png",
    img3:"https://i.ibb.co/1dSHr61/3.png"
    
   
   ,
  },
  {
    id: "8",
    image: "https://i.ibb.co/1MC5v2w/img-3.png",

    url: "https://warehouse-e166b.web.app/",
    type: "development",
    server: "https://github.com/Kanizfatema47/fruithouse-server",
    client: "https://github.com/Kanizfatema47/fruithouse-client",
    name: "Fruit Warehouse",
    img1:"https://i.ibb.co/WzfchPr/1-1.png",
    img2:"https://i.ibb.co/WWFdDpr/1-2.png",
    img3:"https://i.ibb.co/svC8V1X/1-3.png"
  },
  {
    id: 6,

    image: "https://i.ibb.co/gDzpT9Z/img2.png",
    url: "https://photography-8cd93.web.app/",
    type: "design",
    server: "",
    client: "https://github.com/Kanizfatema47/kphoto-client",
    name: "KPhoto",
    img1:"https://i.ibb.co/dfL7ZWc/2-3.png",
    img2:"https://i.ibb.co/f0Xk4V1/2-2.png",
    img3:"https://i.ibb.co/7X7S7jB/2-1.png"
  },

  {
    id: "4",

    image: "https://i.ibb.co/0KJWK0H/img5.png",
    url: "https://kanizfatema47.github.io/Second-assignment/",
    type: "design",
    server: "",
    client: "",
    name: "Mission"
  },

  {
    id: "5",

    image: "https://i.ibb.co/6Yx33Q7/img1.png",
    url: "https://kanizfatema47.github.io/firstAssignment/",
    type: "design",
    server: "",
    client: ""
  },




];



export default Data;